import React from 'react';

import { useTranslation } from 'react-i18next';

import { CopyModule, YatSprite } from '@pkg/components';
import OpenYat from '@pkg/components/Elements/OpenYat/OpenYat';

import { type EmojiId } from '@app/client/common';

import './ShareModule.scss';

interface YatShareModuleProps {
    yat: EmojiId;
    iconSize?: string;
    classes?: string;
}

const YatShareModule = ({ yat, iconSize, classes }: YatShareModuleProps) => {
    const { t } = useTranslation('translation');

    return (
        <div key={yat} className={`yat-share-module ${classes}`}>
            <div className="yat-share-module__holder">
                <div className="yat-share-module__yat">
                    {t('yat_url')}/{/* eslint-disable-next-line react/jsx-no-undef */}
                    <YatSprite forceSprite={true} emojiID={yat} />
                </div>
                <div className="yat-share-module_buttons">
                    <CopyModule iconSize={iconSize} emojiId={yat} /> <OpenYat emojiId={yat} iconSize={iconSize} />
                </div>
            </div>
        </div>
    );
};

export default YatShareModule;
